import {
  drawPointsAnim,
  drawAngleAnim,
  drawLineAnim,
  drawCircleAnim,
} from "../../../../../../src/animation/Circle/helpers/drawHelpers";
import { drawAngleBgAnim, reduceOpacityAnim } from "./helpers/drawHeplers";
import { drawMovePoints } from "./helpers/drawMovePoints";

import { ANGLE_NAMES_FOR_ANIM, RADIANS } from "../../types/Config";
import { drawMoveAngles } from "./helpers/drawMoveAngleHelpers";
import { ContextType } from "../../types/Interface";


export async function runCircleAnimation(context: ContextType, cb: () => void) {
  const {
    circle,
    LineManager,
    PointManager,
    AngleManager,
    AngleBgManager
  } = context;


  const [cCoord, cSide1Point, cSide2Point, cCircumPoint] = PointManager.getPoints().map((p: any) => ({ x: p.x, y: p.y }));
  const centerPoint = PointManager.getPoints()[0];

  // Circle
  centerPoint.draw(cCoord);
  circle.setRadians(Array(3).fill(RADIANS[2]));
  
  await drawPointsAnim([centerPoint]);
  await drawCircleAnim(circle, RADIANS[2] - 2 * Math.PI, 2, true, cCoord);

  drawLineAnim(LineManager.lLine1CirSide2, cCircumPoint, cSide2Point);
  await drawLineAnim(LineManager.rLine1CirSide1, cCircumPoint, cSide1Point);
  await drawAngleAnim(AngleManager.circumAngle, ANGLE_NAMES_FOR_ANIM.circum);

  circle.setRadians([RADIANS[0], RADIANS[0], RADIANS[2]])

  const finalRadian = RADIANS[1];

  await drawCircleAnim(circle, finalRadian, 1, false, cCoord);
  await drawAngleBgAnim(AngleBgManager.circumBg, finalRadian, cCoord);
  
  circle.setRadians(RADIANS);

  await drawMovePoints([AngleBgManager.circumBg], circle, PointManager, AngleManager, LineManager);

  drawLineAnim(LineManager.lLine2CenSide1, cCoord, cSide2Point);
  await drawLineAnim(LineManager.rLine2CenSide2, cCoord, cSide1Point);
  await drawMoveAngles(circle, PointManager, AngleManager);

  await drawAngleAnim(AngleManager.centerAngle, ANGLE_NAMES_FOR_ANIM.center);
  await drawAngleBgAnim(AngleBgManager.centerBg, finalRadian, cCoord);

  await drawMovePoints([AngleBgManager.circumBg, AngleBgManager.centerBg], circle, PointManager, AngleManager, LineManager);

  reduceOpacityAnim(AngleBgManager.centerBg)
  await reduceOpacityAnim(AngleBgManager.circumBg)

  cb();
}
